import { useEditorContext } from "../EditorContext";
import FormLabel from "../FormCommonField/FormLabel";
import { getBorderStyleObj } from "../FormText/FormBaseStyle";

export default ({ data }) => {
  const {
    placeholder,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
  } = data;

  const { state } = useEditorContext();
  const borderStyleObj = getBorderStyleObj(state.root.data);
  return (
    <div style={{ paddingTop, paddingBottom, paddingRight, paddingLeft, textAlign: "left" }}>
      <FormLabel data={data} />
      <div>
        <div style={{ height: 110, ...borderStyleObj }}>
          {placeholder && (
            <div
              style={{
                padding: "0 8px",
                color: "#707070",
              }}
            >
              {placeholder}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
